import React, { forwardRef } from "react";
import { Row, Col } from "antd";
import { FormattedMessage } from "react-intl";
import DynamicItem from "../../../components/forms/DynamicItem";
import Surface from "../../../components/layouts/Surface";
import Phone from "../../../components/tables/Phone";
import RelativeType from "../../../components/tables/RelativeType";
import FormHeader from "../../../components/forms/FormHeader";
import { ReactComponent as RelativesImg } from "../../../assets/no-relatives.svg";

const Relatives = forwardRef((props, ref) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface>
        <FormHeader title={<FormattedMessage id="app.employees.relatives" />} />
        <Row>
          <Col span={24}>
            <DynamicItem
              resource={"employees"}
              action={"editor"}
              emptyImg={<RelativesImg />}
              twoColumns={true}
              name="relatives"
              category="employee"
              addText={<FormattedMessage id="app.employees.addRelative" />}
              tableItems={[
                {
                  title: "first_name",
                  type: "input",
                  required: true,
                  ellipsis: true,
                },
                {
                  title: "last_name",
                  type: "input",
                  ellipsis: true,
                },
                {
                  title: "relative_type_id",
                  type: "selectItem",
                  metadataName: "relative_types",
                  render: RelativeType,
                  // width: "80px",
                  required: true,
                },
                {
                  title: "phone_number",
                  type: "phone",
                  render: Phone,
                  ellipsis: true,
                  responsive: ["xl"],
                },
                {
                  title: "mobile_number",
                  type: "phone",
                  ellipsis: true,
                  render: Phone,
                  responsive: ["lg"],
                },
                {
                  title: "email",
                  type: "input",
                  email: true,
                  responsive: ["xl"],
                  ellipsis: true,
                },
              ]}
            />
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default Relatives;
